<section>
  <app-expert-group-portal-header
    *ngIf="expertGroupPortal"
    selectedNavItem="discussions"
    [expertGroupPortal]="expertGroupPortal"
  ></app-expert-group-portal-header>
  <div class="container m-b-xxl m-t-alt">
    <div class="columns is-multiline">
      <div class="column is-12">
        <h2 class="title is-2 mb-0">Discussions</h2>
        <div
          *ngIf="discussionListPage?.content"
          [innerHTML]="discussionListPage.content"
        ></div>
        <div *ngIf="!discussionListPage">
          <div
            class="mt-6 temporary-item temporary-item--dark temporary-desc"
          ></div>
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
        </div>
      </div>
    </div>

    <!-- Cards -->
    <div class="columns is-multiline">
      <ng-container *ngIf="paginator">
        <div
          class="column is-6-tablet is-4-desktop"
          *ngFor="let discussion of paginator.data"
        >
          <app-discussion-card
            [discussion]="discussion"
            [expertGroupPortal]="expertGroupPortal"
          ></app-discussion-card></div
      ></ng-container>

      <!-- Loading -->
    </div>
    <div class="columns is-multiline" *ngIf="!paginator">
      <div class="column is-6-tablet is-4-desktop">
        <div class="lc lc--discussion">
          <div></div>
        </div>
      </div>
      <div class="column is-6-tablet is-4-desktop">
        <div class="lc lc--discussion">
          <div></div>
        </div>
      </div>
      <div class="column is-6-tablet is-4-desktop">
        <div class="lc lc--discussion">
          <div></div>
        </div>
      </div>
      <div class="column is-6-tablet is-4-desktop">
        <div class="lc lc--discussion">
          <div></div>
        </div>
      </div>
      <div class="column is-6-tablet is-4-desktop">
        <div class="lc lc--discussion">
          <div></div>
        </div>
      </div>
      <div class="column is-6-tablet is-4-desktop">
        <div class="lc lc--discussion">
          <div></div>
        </div>
      </div>
    </div>

    <app-pagination
      *ngIf="paginator"
      [paginator]="paginator"
      (pageChange)="goToPage($event)"
    ></app-pagination>
  </div>
</section>
